import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, Input } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import Loader3 from '../../../../../../CommonElements/Spinner/loader3';
import '../style/style.css';

export default function Component({ seriess, height, tooltip, width }) {


  // Initialize with default data
  const [series, setSeries] = useState([80, 20]); // Default dummy data

  // Update series when seriess prop changes
  useEffect(() => {
    if (seriess && seriess.length > 0) {

      // const activeValue = seriess[0] ?? 0;
      // setSeries([activeValue, 100 - activeValue]);
      setSeries([parseFloat(seriess[0]), parseFloat((100 - seriess[0]).toFixed(1))]);
    } else {
      setSeries([0, 0]);
    }
  }, [seriess]);
  // Determine the color based on the compliance value
  const getComplianceColor = (value) => {
    if (value === 100) {
      return '#54BA4A'; // Green for 100% compliance
    } else if (value > 95 && value < 100) {
      return '#FFC107'; // Amber for >95% and <100% compliance
    } else {
      return '#175fa4'; // Default blue for ≤95% compliance
    }
  };

  const factoryID = JSON.parse(localStorage.getItem('userData')).factory.id

  const chartOptions = {
    chart: {
      type: 'donut',
      height: 240,
    },
    series: series,
    labels: ['Over all compliance', 'Non compliance'],
    colors: [getComplianceColor(series[0]), '#dde8f9'],
    
    plotOptions: {
      pie: {
        startAngle: 0, // Ensures no gap at the top
        endAngle: 360, // Completes the circle
        donut: {
          size: '70%',
          labels: {
            show: true,
            name: { show: false },
            value: {
              show: true,
              fontSize: '26px',
              fontFamily: 'Inter, sans-serif',
              fontWeight: 600,
              color: '#595959',
              formatter: function (val) {
                return val + '%';
              }
            },
            total: {
              show: true,
              label: 'Total',
              fontSize: '16px',
              color: '#595959',
              formatter: function () {
                return series[0] + '%';
              }
            }
          }
        },
      }
    },
    stroke: { show: false },
    tooltip: {
      enabled: true,
      custom: function () {
        if (tooltip && tooltip.length > 0) {
          // Generate HTML with line breaks for tooltip
          const tooltipfilter = tooltip.filter((item)=>(item.name!=='No Go' && item.name!=='Machine Guard'))
          const tooltipContent = factoryID==14 ? (tooltipfilter.map(item => `<div>${item.name}: ${item.name == 'Machine Guard' || item.barValue == -1 ? 'N/A' : item.barValue}</div>`).join('')) : (tooltip.map(item => `<div>${item.name}: ${item.name == 'Machine Guard' || item.barValue == -1 ? 'N/A' : item.barValue}</div>`).join(''));
          return `<div style="padding: 5px; font-size: 12px; line-height: 1.5; color: #ffffff;">
                    ${tooltipContent}
                  </div>`;
        }
        return '<div style="padding: 5px; font-size: 12px; color: #ffff;">No data</div>';
      }
    },
    dataLabels: { enabled: false },
    legend: { show: false },
    responsive: [
      {
        breakpoint: 1400,
        options: {
          chart: { width: '200px', height: '240px' },
        },
      },
      {
        breakpoint: 1024,
        options: {
          chart: { width: '80%', height: '240px' },
        },
      },
      {
        breakpoint: 768,
        options: {
          chart: { width: '100%', height: '240px' },
        },
      },
    ],
  };

  // Ready to render chart

  return (
    <Card className='p-0 m-0 d-flex justify-content-center align-items-center' style={{ boxShadow: 'none' }}>
      <CardHeader className='d-flex justify-content-center align-items-center' style={{fontSize:'20px', fontWeight:'600'}}>Overall Compliance Site Score</CardHeader>
      <CardBody>
      {seriess?.length <= 0 ? (
        <div className='d-flex justify-content-center align-items-center' style={{ width: '100%', height: '50vh' }}>
          No data available
        </div>
      ) : (
        <>
          <div >
            <ReactApexChart
              options={chartOptions}
              series={series}
              type="donut"
              height={300}
            />
          </div>
        </>
      )}
      </CardBody>
    </Card>
  );
}